module.exports = __webpack_public_path__ + "static/img/btn2.1ae6fd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/onlinePreview/btn2.png
// module id = IH9C
// module chunks = 2